<script>
    import {
      Modal,
      ModalBody,
      ModalFooter,
      ModalHeader,
    } from "sveltestrap";
    import alertify from "alertifyjs";
    import backend from "../../../../server";
  
    export let showCategoryModal;
    export let closeModal;
    export let refreshList;
  
    let category = "";
    let gameType = "";
  
    function prepareNewType() {
      showCategoryModal = true;
    }

    function closeCategoryModal() {
      showCategoryModal = false;
    }
    const save = async () => {
      if (!category || !gameType) {
        return alertify.error("Completa ambos campos");
      }
  
      try {
        await backend.games.addCategory({ category, type: gameType });
        alertify.success("Categoría guardada");
        closeModal();
        refreshList(); // opcional: recarga lista si hace falta
      } catch (err) {
        alertify.error("Error al guardar categoría");
      }
    };
    
  </script>
  
  <Modal isOpen={showCategoryModal} toggle={closeModal}>
    <ModalHeader toggle={closeModal}>Nueva Categoría</ModalHeader>
    <ModalBody>
      <div class="mb-3">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="form-label">Nombre de Categoría</label>
        <input class="form-control" bind:value={category} />
      </div>
      <div class="mb-3">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="form-label">Tipo de Juego</label>
        <input class="form-control" bind:value={gameType} />
      </div>
    </ModalBody>
    <ModalFooter>
      <button class="btn btn-secondary" on:click={closeModal}>Cancelar</button>
      <button class="btn btn-primary" on:click={save}>Guardar</button>
    </ModalFooter>
  </Modal>
  
